export default __webpack_public_path__ + "static/media/shivji.695507ae89ad7243f3316b81a7d7d1fe.webp";